import { accentColorsDarkMode, accentColorsLightMode } from './data/themes';
import { AccentColorName, HexColor, ThemeMode } from './types';

export function isAccentColorName(accentColor: string): accentColor is AccentColorName {
  return Object.keys(accentColorsLightMode).includes(accentColor);
}

export function getHexFromAccentColor(accentColor: string | undefined, mode: ThemeMode) {
  const palette = mode === 'light' ? accentColorsLightMode : accentColorsDarkMode;
  if (accentColor && isAccentColorName(accentColor)) {
    return palette[accentColor];
  }
  return accentColor?.startsWith('#') ? (accentColor as HexColor) : palette.blue;
}
